import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { publicPayApi } from '@/services/api/billing'
import { Button } from '@/components/common'

export function PublicPayPage() {
  const { token } = useParams()
  const [search] = useSearchParams()
  const [data, setData] = useState<any>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    if (!token) return
    publicPayApi.get(token).then(setData).catch(() => setError('Link ungültig'))
  }, [token, search])
  if (error) return <div className="p-8 max-w-lg mx-auto">{error}</div>
  if (!data) return <div className="p-8 max-w-lg mx-auto">Laden…</div>
  const go = async (kind: 'stripe' | 'paypal') => {
    if (!token) return
    const r = kind === 'stripe' ? await publicPayApi.stripe(token) : await publicPayApi.paypal(token)
    if (r.url) window.location.href = r.url
  }
  return (
    <div className="p-8 max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-2">Rechnung {data.invoice_number}</h1>
      <p className="mb-1">{data.school_name}</p>
      <p className="mb-4">{String(data.period_month).padStart(2, '0')}/{data.period_year} · {data.remaining} {data.currency}</p>
      <div className="flex gap-2 flex-wrap">
        {data.stripe && <Button onClick={() => go('stripe')}>Stripe</Button>}
        {data.paypal && <Button onClick={() => go('paypal')}>PayPal</Button>}
        <a className="underline self-center" href={`/api/v1/billing/pay/${token}/pdf`} target="_blank" rel="noreferrer">PDF</a>
      </div>
      {data.has_qr && <p className="mt-4 text-sm text-gray-600">QR-Ref {data.qr_reference}</p>}
    </div>
  )
}
